/**
 * FAQHero — Weidner Via6 page hero for /frequently-asked-questions.
 * See `FloorPlansHero.tsx` and `_PageImageHeroBody.tsx` for the shared
 * pattern. Owns its slot registration, contentSchema, and hidden
 * literal-path anchors; visual rendering is delegated to the body.
 */

import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, EditableSlotGroup } from '@vibesites/runtime/react';
import { PageImageHeroBody } from './_PageImageHeroBody';

const bgDef = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Frequently asked questions hero image',
    },
  },
  sourceBinding: {
    collection: 'photo_gallery',
    defaultIndex: 0,
    fieldMappings: { image: 'image', alt: 'alt_text' },
  },
};

export function FAQHero() {
  return (
    <>
      <PageImageHeroBody
        titlePath="faqhero.title"
        bgPath="faqhero.bg_image"
        bgDef={bgDef}
        defaultTitle="FAQ"
        keywords={['lobby', 'office', 'leasing', 'clubhouse', 'lounge']}
        pageHint="faqhero"
        altText="Frequently asked questions hero image"
      />

      <RichTextContent
        path="faqhero.title"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      />
      <EditableSlotGroup
        groupPath="faqhero.bg_image"
        definition={bgDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FAQHero',
  displayName: 'FAQ Hero',
  tokens: {
    'faqhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: 'FAQ',
    },
  },
  slotGroups: {
    'faqhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: {
          label: 'Image',
          type: 'image',
          defaultField: 'property_featured_image',
        },
        alt: {
          label: 'Alt Text',
          type: 'text',
          defaultValue: 'Frequently asked questions hero image',
        },
      },
      sourceBinding: {
        collection: 'photo_gallery',
        defaultIndex: 0,
        fieldMappings: { image: 'image', alt: 'alt_text' },
      },
    },
  },
};

(FAQHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default FAQHero;
